var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullBoldStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2637 21.4097C16.414 21.496 16.5788 21.5381 16.7436 21.5381C16.9592 21.5381 17.1737 21.4654 17.353 21.3199C17.6723 21.0654 17.8308 20.6347 17.7645 20.2086L16.7571 13.8137L21.0272 9.28564C21.3122 8.98452 21.4138 8.53229 21.2925 8.11982C21.1723 7.70735 20.8468 7.40737 20.4561 7.34488L14.5474 6.40404L11.9076 0.5795C11.5573 -0.193167 10.4007 -0.193167 10.0504 0.5795L7.41062 6.40404L1.50195 7.34488C1.11121 7.40737 0.785775 7.70735 0.66555 8.11982C0.544288 8.53229 0.645858 8.98452 0.930875 9.28564L5.20096 13.8137L4.19355 20.2086C4.12722 20.6347 4.28579 21.0654 4.60501 21.3199C4.92112 21.5744 5.34399 21.6097 5.6943 21.4097L10.979 18.3827L16.2637 21.4097Z",
    fill: "#FFC84E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBoldStar);
export default __webpack_public_path__ + "static/media/full-bold-star.99acfa3bbbaff250d2047e7a300adeae.svg";
export { ForwardRef as ReactComponent };